import { Box, styled, Typography } from '@mui/material';

export const ButtonContentStyle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== '$hidden' && prop !== '$disabled',
})<{ $hidden?: boolean; $disabled?: boolean }>(({ $hidden }) => ({
  visibility: $hidden ? 'hidden' : 'visible',
  color: 'inherit',
  fontWeight: 'inherit',
  fontSize: 'inherit',
}));

export const ButtonLoaderStyle = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: currentcolor;
  pointer-events: none;
`;
